import { render, staticRenderFns } from "./ProdutoMesa.vue?vue&type=template&id=4e2120b6&scoped=true&"
import script from "./ProdutoMesa.vue?vue&type=script&lang=js&"
export * from "./ProdutoMesa.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoMesa.vue?vue&type=style&index=0&id=4e2120b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2120b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VContainer,VImg,VRadio,VRadioGroup,VTextarea})
